﻿import * as Res from "./res";
import { createElement, getById } from "./_dom";
import { toolaction } from "./actionButtons";

const preferenceOptions = {
	fontsize: [
		{ id: "small", href: "#fontsize-small", text: "Small font" },
		{ id: "normal", href: "#fontsize-normal", text: "Normal font" },
		{ id: "large", href: "#fontsize-large", text: "Large font" }
	],
	colortheme: [
		{
			id: "auto",
			href: "#colortheme-auto",
			class: "ui-icon-theme-auto",
			text: "OS Theme"
		}, {
			id: "light",
			href: "#colortheme-light",
			class: "ui-icon-theme-light",
			text: "Light Theme"
		}, {
			id: "dark",
			href: "#colortheme-dark",
			class: "ui-icon-theme-dark",
			text: "Dark Theme"
		}
	]
};

const preferenceDefaults = {
	fontsize: "normal",
	colortheme: "light"
};

function validateOption(section, value) {
	const defaultValue = preferenceDefaults[section];
	return value && value !== defaultValue && preferenceOptions[section].find(t => t.id === value) ? value : undefined;
}

const getPreferenceKey = (section) => `preference-${section}`;
const getDataSetKey = (section) => `preference${section.substring(0, 1).toUpperCase()}${section.substring(1).toLowerCase()}`;

function updatePreference(section, value, persist) {
	value = validateOption(section, value);
	if (typeof(value) === "string" && value) {
		document.documentElement.dataset[getDataSetKey(section)] = value;
		if (persist)
			localStorage.setItem(getPreferenceKey(section), value);
	} else {
		delete document.documentElement.dataset[getDataSetKey(section)];
		if (persist)
			localStorage.removeItem(getPreferenceKey(section));
	}
}

function getAvailablePreferencesList() {
	const defaultPrefs = Object.keys(preferenceOptions);
	return defaultPrefs;
};

// call ASAP
function setPreferences(/** @type {string[]|undefined}*/sections) {
	if (sections === undefined) {
		sections = getAvailablePreferencesList();
	}
	if (sections) {
		sections.forEach(section => updatePreference(section, localStorage.getItem(getPreferenceKey(section))));
	}
}

// <button class="v3-button-preferences v3-button ui-icon-preferences" data-preferences="{$options}" data-popper-placement="top-end"><span class="ui-icontext">Preferences</span></button>

function createMenu(preferenceSections) {
	const menu = [];
	preferenceSections.forEach((section, i) => {
		if (i) menu.push({ "text": "---" });
		const value = document.documentElement.dataset[getDataSetKey(section)] || preferenceDefaults[section];
		preferenceOptions[section].forEach(item => {
			if (item.id) {
				item = { ...item, checked: item.id === value, text: Res.getString(`dbui.settings.${section}.${item.id}`) };
			}
			menu.push(item);
		});
	});
	return menu;
}

function init(context) {
	const preferenceSections = getAvailablePreferencesList();
	if (preferenceSections) {
		const rootStyle = window.getComputedStyle(document.documentElement);
		// check if fontSize property is programmatically disabled
		const fontSizeName = "fontsize";
		const fontSizeIndex = preferenceSections.indexOf(fontSizeName);
		if (fontSizeIndex >= 0) {
			const sizeSmall = rootStyle.getPropertyValue("--v3-font-pref-small");
			const sizeLarge = rootStyle.getPropertyValue("--v3-font-pref-large");
			if (sizeSmall == sizeLarge) {
				preferenceSections.splice(fontSizeIndex, 1);
				updatePreference(fontSizeName, "", true);
			}
		}
		// check if colortheme property is programmatically disabled
		const colorThemeName = "colortheme";
		const colorThemeIndex = preferenceSections.indexOf(colorThemeName);
		if (colorThemeIndex >= 0) {
			if (rootStyle.colorScheme?.indexOf("only") >= 0) {
				preferenceSections.splice(colorThemeIndex, 1);
				updatePreference(colorThemeName, "", true);
			}
		}
		if (preferenceSections.length) {
			const footer = getById(context, "td-footer");
			if (footer) {
				const button = createElement("button", { "class": "v3-button-preferences v3-button ui-icon-preferences ui-icon-only", "data-popper-placement": "top-end" }, createElement("span", { "class": "ui-icontext" }, "Preferences"));
				footer.append(button);
				const toolbutton = toolaction(button, { menu: createMenu(preferenceSections) });
				button.addEventListener("v3-toolaction.menuclick", e => {
					e.preventDefault();
					const target = e.detail;
					const [section, value] = target.getAttribute("href").substring(1).split("-");
					updatePreference(section, value, true);
					toolbutton.setOption("menu", createMenu(preferenceSections));
				});
			}
		}
	}
}

export { init, setPreferences };